import { CmsApiSupportContactFormBlockData } from 'modules/cms/api/types/blocks/CmsApiSupportContactFormBlock';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpSupportContactFormBlock({
  content,
  data,
  blockId,
}: CmsAmpBlockMappingComponentProps<CmsApiSupportContactFormBlockData>) {
  const text = getText('Need Help?');
  const buttonText = getText('Contact Us');

  return (
    <CmsAmpHeroBlock
      content={content}
      // @ts-expect-error TS(2322): Type '{ text: string; buttonText: string; reasons:... Remove this comment to see the full error message
      data={{ ...data, text, buttonText }}
      blockId={blockId}
    />
  );
}
